import { getIncidentById, saveRootCauseSummary } from "actions";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

const RootCauseSummary = ({
  summary,
  rootCauseId,
  incidentId,
  previousData,
  goToNextTab,
  isFinalReportGenerated,
}) => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);
  const incidentState = useSelector((state) => state.incidentState);
  const [editableSummary, setEditableSummary] = useState("");
  const [isEdited, setIsEdited] = useState(false);
  const divRef = useRef(null);

  useEffect(() => {
    if (summary) {
      setEditableSummary(summary);
      if (divRef.current) {
        divRef.current.textContent = summary;
      }
      setIsEdited(false); // reset edit state when summary comes from backend
    }
  }, [summary]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const payload = {
      id: rootCauseId,
      summary: editableSummary,
    };

    await dispatch(saveRootCauseSummary(payload));
    await dispatch(getIncidentById(incidentId, "update"));
    setIsEdited(false); // reset after saving
    if (typeof goToNextTab === "function") {
      goToNextTab();
    }
  };

  return (
    <div className="summary-box p-3 border rounded">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="font-20 font-weightr-bold heading-color mb-0">
          Summary
        </h1>
        {!isFinalReportGenerated && (
          <button
            className="add-new-btn"
            onClick={handleSubmit}
            disabled={!isEdited} // disable until user edits
          >
           
            Update
          </button>
        )}
      </div>
      {summary ? (
        <>
          <div
            ref={divRef}
            contentEditable
            suppressContentEditableWarning
            className="font-14 text-muted mb-3"
            style={{
              whiteSpace: "pre-wrap",
              minHeight: "150px",
              maxHeight: "300px",
              overflowY: "auto",
              border: "1px solid #ddd",
              padding: "8px",
              borderRadius: "8px",
            }}
            onInput={(e) => {
              setEditableSummary(e.currentTarget.textContent);
              setIsEdited(true); // mark as edited
            }}
          />
        </>
      ) : (
        <p className="font-14 text-muted mb-3">No summary generated yet.</p>
      )}
    </div>
  );
};

export default RootCauseSummary;
